<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  import { getDataAttribute } from '../../utilities/DataTableUtilities';

  export let e2eAttributeSuffix: string | undefined;
  export let dataTableId: string | undefined;
  export let loading: boolean;
  export let searchPlaceholder: string;

  let eventHandler = new EventHandler();
  let searchValue = '';

  function emitEvent(name: string, detail?: CustomEvent['detail']) {
    eventHandler.dispatch(name, detail || {});
  }
</script>

<div class="mc-datatable__topbar-actions">
  <div class="mc-left-icon-input">
    <span class="mc-left-icon-input__icon">
      <navigation-display-search-24px size="24px" />
    </span>
    <input
      type="search"
      class="mc-left-icon-input__input mc-text-input mc-text-input--s"
      id="withIcon"
      placeholder={searchPlaceholder}
      name="withIcon"
      disabled={loading}
      spellcheck="false"
      {...getDataAttribute(e2eAttributeSuffix, `${dataTableId}SearchInput`)}
      bind:value={searchValue}
      on:input={() => emitEvent('input-search', searchValue)}
    />
  </div>

  <button
    type="button"
    class="mc-button mc-button--s mc-button--square mc-button--bordered {loading
      ? 'is-disabled'
      : ''}"
    {...getDataAttribute(e2eAttributeSuffix, `${dataTableId}FilterButton`)}
    on:click={() => emitEvent('click-filter')}
  >
    <span class="mc-button__icon">
      <navigation-display-filter-24px size="24px" />
    </span>
  </button>

  <button
    type="button"
    class="mc-button mc-button--s mc-button--square mc-button--bordered-neutral {loading
      ? 'is-disabled'
      : ''}"
    {...getDataAttribute(e2eAttributeSuffix, `${dataTableId}SettingsButton`)}
    on:click={() => emitEvent('click-settings')}
  >
    <span class="mc-button__icon">
      <navigation-display-setting-24px size="24px" />
    </span>
  </button>
</div>

<!-- svelte-ignore css-unused-selector -->
<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';

  @import '@mozaic-ds/styles/generic/g.reset.scss';
  @import '@mozaic-ds/styles/components/c.badge';
  @import '@mozaic-ds/styles/components/c.button';
  @import '@mozaic-ds/styles/components/c.datatable-tools';
  @import '@mozaic-ds/styles/components/c.datatable-header';
  @import '@mozaic-ds/styles/components/c.text-input';
  @import '@mozaic-ds/styles/components/c.left-icon-input';
  @import '@mozaic-ds/styles/components/c.links';
  @import '@mozaic-ds/styles/components/c.tag';
  @import '@mozaic-ds/styles/components/c.toggle';
</style>
